import { useEffect, useState } from "react";
import MemberSidebar from "./MemberSidebar";

export default function MemberLayout(props) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const syncSidebar = () => {
      setSidebarOpen(localStorage.getItem("sidebarOpen") === "true");
    };

    localStorage.setItem("sidebarOpen", "false");

    window.addEventListener("storage", syncSidebar);
    return () => window.removeEventListener("storage", syncSidebar);
  }, []);

  return (
    <>
      <div className={`main_container ${sidebarOpen ? "sidebar-open" : ""}`}>
        <div className="limani_body">
          <MemberSidebar />
          {props.children}
        </div>
      </div>
    </>
  );
}
